import 'flatpickr';

export default function initReviewForm () {
  const container = $('#addReview');
  if (container.length) {
    var review,
      ReviewForm = {

        settings: {
          viewport: $('html, body'),
          toggleBtn: $('.review-form__toggle'),
          date: $('.review-form__date input'),
          errorContainer: $('#errors'),
          errors: $('#errors ul')
        },

        init: function () {
          review = this.settings;
          this.toggleForm();
          this.visitDate();
        },

        toggleForm: function () {
          review.toggleBtn.on('click', function () {
            container.addClass('visible');
            review.viewport.animate({
              scrollTop: container.offset().top
            }, 0);
          });
        },

        visitDate: function () {
          review.date.flatpickr({
            altInput: true
          });
        }
      }.init();

    $('#new_review').submit(function (e) {
      $.ajax({
        type: 'POST',
        url: '/reviews',
        data: $('#new_review').serialize(),
        success: function (data) {
          $('#addReview').hide();
          $('#completeReview').fadeIn(150);
        },
        error: function (data) {
          const json = JSON.parse(data.responseText);
          let errorText = '';
          for (var key in json) {
            const obj = json[key];
            for (var prop in obj) {
              errorText += '<li>' + key + ' ' + obj[prop] + '</li>';
              break;
            }
            review.errors.html(errorText);
          }

          // Toggle classes
          if (json['title']) {
            const $this = $('#review_title');
            $this.addClass('error');
            $this.keypress(function () {
              $this.removeClass('error');
            });
          }
          if (json['comment']) {
            const $this = $('#review_comment');
            $this.addClass('error');
            $this.keypress(function () {
              $this.removeClass('error');
            });
          }
          review.errorContainer.show();
        }
      });
      e.preventDefault();
    });
  }
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/shared/reviewForm.js